import * as Sentry from '@sentry/react'

// We don't initialize in corp because we don't want to use full
// story quota for nonapplicants
let isInitialized = false

export function initializeFullStory() {
  const domain = window.location.hostname
  if (isInitialized) {
    console.warn('initializeFullStory() already initialized')
    return
  }

  if (domain.startsWith('app.')) {
    Sentry.init({
      dsn: 'https://76d3036411a24522b087502453209d9c@o4506108471738368.ingest.sentry.io/4506108472786944',
      integrations: [Sentry.browserTracingIntegration()],
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/app\.twodots\.(net|com)\/api/,
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 1, // todo: Ramp back down to 0.3 once finished w/ income survey testing
      replaysOnErrorSampleRate: 1,
    })

    // Keep the recorder out of the initial bundle even though Sentry exports
    // replayIntegration and init from the same SDK entry point.
    import('./sentryReplay')
      .then(({ initializeSentryReplay }) => {
        initializeSentryReplay()
      })
      .catch((error) => {
        console.warn('Failed to load Sentry Replay integration', error)
      })

    isInitialized = true
  }
}

export function getReactErrorHandlers() {
  if (!isInitialized) {
    return undefined
  }

  // React 19 no longer rethrows render errors caught by an error boundary.
  // Report them through the root callbacks, including their component stack.
  return {
    onCaughtError: Sentry.reactErrorHandler(),
    onUncaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  }
}

export function identifyUsers(userId: string, email: string) {
  if (!isInitialized) {
    return
  }

  Sentry.setUser({
    id: userId,
    email,
  })
}

export function setFullStoryUserVars(workflowId: string, applicantId: string) {
  if (!isInitialized) {
    return
  }

  Sentry.setUser({
    workflowId,
    applicantId,
  })
}
